import React from "react";

import { FormattedMessage } from "react-intl";

import { useTheme } from '@mui/material/styles';

import Button from "@mui/material/Button";
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import DialogActions from "@mui/material/DialogActions";
import { Rating } from "@mui/material";
import RatingElement from "../rating-element";

import ClearIcon from '@mui/icons-material/Clear';

export default function CalledClassificationHistoryDialog(props) {
  const {
    open,
    handleOpenOrClose,
    intl,
    data,
  } = props;

  const theme = useTheme();
  const paperRefs = React.useRef({});

  function renderNoteAssigned(satisfactionSurveyType, note) {
    let type;

    if (!satisfactionSurveyType) {
      type = 6
    } else {
      type = satisfactionSurveyType || 6
    }

    return (
      <RatingElement
        type={type}
        value={note}
      />
    )
  }

  function renderHistory(item, index) {
    const originOfSurveyResponse = item.originOfSurveyResponse ? item.originOfSurveyResponse : '';
    const createdAtData = item.createdAtData ? item.createdAtData : '';
    const noteassigned = item.noteassigned ? item.noteassigned : null;
    const observationassigned = item.observationassigned ? item.observationassigned : intl.formatMessage({ id: "called.classification.history.modal.no.observations" });

    const noterequest = item.noterequest ? item.noterequest : null;
    const observationrequest = item.observationrequest ? item.observationrequest : intl.formatMessage({ id: "called.classification.history.modal.no.observations" });

    const satisfactionSurveyType = item?.called?.satisfactionsurvey?.satisfactionsurveyquestions?.[0]?.satisfactionsurveyquestionstypeid || 6;

    return (
      <Grid item xs={12} key={index}>
        <Paper ref={el => (paperRefs.current[index] = el)} elevation={1} sx={{ p: 2, mb: 2, borderLeft: `4px solid ${theme.palette.primary.main}` }}>
          <Box sx={{ display: "flex", flexDirection: "column", pb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <Typography variant="subtitle2" component="div">
                {intl.formatMessage({ id: "csat.requester.to.assigned" })}
              </Typography>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems:  'baseline', gap: 6 }}>
                {originOfSurveyResponse &&
                  <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                    <Typography variant="subtitle2" component="div">
                      {intl.formatMessage({ id: "origin.of.survey.response" })}
                    </Typography>
                    
                    <Typography variant="subtitle2" component="div">
                      {originOfSurveyResponse}
                    </Typography>
                  </Box>
                }

                <Typography variant="subtitle2" component="div">
                  {createdAtData}
                </Typography>
              </Box>
            </Box>
              
            <Box sx={{ pt:1, pb: 1.8, alignSelf: 'flex-start' }}>
              {renderNoteAssigned(satisfactionSurveyType, noteassigned)}
            </Box>

            <Typography color="text.secondary">
              {observationassigned}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", pb: 1 }}>
            <Typography variant="subtitle2" component="div">
              {intl.formatMessage({ id: "csat.assigned.to.requester" })}
            </Typography>
            
            {noterequest
              ? <Rating name="read-only" value={noterequest} readOnly sx={{ pb: 1.8 }} />
              : <p>N/A</p>
            }

            <Typography color="text.secondary">
              {observationrequest}
            </Typography>
          </Box>
        </Paper>
      </Grid>
    )
  }

  if (!open) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleOpenOrClose}
      aria-labelledby="newuser-dialog-title"
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="newuser-dialog-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6"><FormattedMessage id="called.classification.history.modal.title" /></Typography>
          <IconButton aria-label="close" size="small" onClick={handleOpenOrClose}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          width: '100%',
          minHeight: '200px',
          p: 0
        }}
      >
        <Box sx={{ overflowY: 'auto', maxHeight: { xs: '50vh', sm: '55vh' }, p: 2 }}>
          <Grid container spacing={2}>

            {data && data.length > 0 &&
              data.map(renderHistory)
            }
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            color='primary'
            type="button"
            onClick={handleOpenOrClose}
            sx={{ minWidth: 120 }}
          >
            {intl.formatMessage({ id: "close" })}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
